import { apiProvider } from "./core/provider";

const apiAvailability = {};

apiAvailability.getInspectorAvailability = function (userId) {
  return apiProvider.get(`availability/inspector/${userId}`);
};

apiAvailability.updateSchedule = function (userId, schedule) {
  return apiProvider.put(`availability/inspector/${userId}/schedule`, schedule);
};

apiAvailability.addOverride = function (userId, override) {
  return apiProvider.post(`availability/inspector/${userId}/override`, override);
};

apiAvailability.removeOverride = function (userId, overrideId) {
  return apiProvider.delete(`availability/inspector/${userId}/override`, overrideId);
};

apiAvailability.setDayLocation = function (userId, weekday, workAreaId) {
  return apiProvider.put(`availability/inspector/${userId}/daylocation`, {
    weekday: weekday,
    workAreaId: workAreaId,
  });
};

apiAvailability.getOverview = function (year, month) {
  return apiProvider.get(`availability/overview/${year}/${month}`);
};

apiAvailability.getAvailableOnDate = function (date, countyId) {
  let url = `availability/date/${date}`;
  if (countyId) {url += `?countyId=${countyId}`;}
  return apiProvider.get(url);
};

apiAvailability.getSchedulers = function () {
  return apiProvider.get("schedulers");
};

apiAvailability.getInspectorStates = function () {
  return apiProvider.get("availability/inspector-states");
};

apiAvailability.getWorkStates = function () {
  return apiProvider.get("availability/work-states");
};

export { apiAvailability };
